/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CustomAttributeTypedArgument from './CustomAttributeTypedArgument';
import MemberInfo from './MemberInfo';

/**
 * The CustomAttributeNamedArgument model module.
 * @module model/CustomAttributeNamedArgument
 * @version V1
 */
class CustomAttributeNamedArgument {
    /**
     * Constructs a new <code>CustomAttributeNamedArgument</code>.
     * @alias module:model/CustomAttributeNamedArgument
     */
    constructor() { 
        
        CustomAttributeNamedArgument.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomAttributeNamedArgument</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomAttributeNamedArgument} obj Optional instance to populate.
     * @return {module:model/CustomAttributeNamedArgument} The populated <code>CustomAttributeNamedArgument</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomAttributeNamedArgument();

            if (data.hasOwnProperty('memberInfo')) {
                obj['memberInfo'] = MemberInfo.constructFromObject(data['memberInfo']);
            }
            if (data.hasOwnProperty('typedValue')) {
                obj['typedValue'] = CustomAttributeTypedArgument.constructFromObject(data['typedValue']);
            }
            if (data.hasOwnProperty('memberName')) {
                obj['memberName'] = ApiClient.convertToType(data['memberName'], 'String');
            }
            if (data.hasOwnProperty('isField')) {
                obj['isField'] = ApiClient.convertToType(data['isField'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomAttributeNamedArgument</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomAttributeNamedArgument</code>.
     */
    static validateJSON(data) {
        // validate the optional field `memberInfo`
        if (data['memberInfo']) { // data not null
          MemberInfo.validateJSON(data['memberInfo']);
        }
        // validate the optional field `typedValue`
        if (data['typedValue']) { // data not null
          CustomAttributeTypedArgument.validateJSON(data['typedValue']);
        }
        // ensure the json data is a string
        if (data['memberName'] && !(typeof data['memberName'] === 'string' || data['memberName'] instanceof String)) {
            throw new Error("Expected the field `memberName` to be a primitive type in the JSON string but got " + data['memberName']);
        }

        return true;
    }


}



/**
 * @member {module:model/MemberInfo} memberInfo
 */
CustomAttributeNamedArgument.prototype['memberInfo'] = undefined;

/**
 * @member {module:model/CustomAttributeTypedArgument} typedValue
 */
CustomAttributeNamedArgument.prototype['typedValue'] = undefined;

/**
 * @member {String} memberName
 */
CustomAttributeNamedArgument.prototype['memberName'] = undefined;

/**
 * @member {Boolean} isField
 */
CustomAttributeNamedArgument.prototype['isField'] = undefined;






export default CustomAttributeNamedArgument;

